import PasswordReset from '@/shared/publish/Homework/PasswordReset';
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/publish/Homework/PasswordReset')({
  component: RouteComponent,
})

function RouteComponent() {
  return <PasswordReset />
}
